import { isArray } from '../Types/isArray';
import { isFunction } from '../Types/isFunction';
import { isIterator } from '../Types/isIterator';
import { isNullOrUndef } from '../Types/isNullOrUndef';
import { isObject } from '../Types/isObject';
import { isSet } from '../Types/isSet';
var breaker = new Error();
breaker.breaker = true;
/**
 * Loops over arrays or objects and applies a given callback
 *
 * Will work with Arrays, Objects, Map, Set and interators
 *
 * @param list The array or object to iterate
 * @param callback The callback to apply. Params are: (value, key, iteratedObject)
 */
export function forEach(list, callback) {
    if (isNullOrUndef(list)) {
        return;
    }
    var _k = 0;
    // Fast lane for arrays
    if (isArray(list)) {
        for (_k = 0; _k < (list).length; _k++) {
            if (callback(list[_k], _k, list) === false) {
                break;
            }
        }
        return;
    }
    if (isObject(list) || isFunction(list)) {
        // Handle for-each functions on sets and maps
        if (typeof list.forEach === 'function') {
            var objectIsSet_1 = isSet(list);
            try {
                list.forEach(function (v, k) {
                    if (callback(v, objectIsSet_1 ? _k : k, list) === false) {
                        throw breaker;
                    }
                    ++_k;
                });
            }
            catch (e) {
                if (e.breaker !== true) {
                    throw e;
                }
            }
            return;
        }
        // Handle iterators
        if (isIterator(list)) {
            var it_1 = list[Symbol.iterator]();
            if (isFunction(it_1.next)) {
                for (var nextValue = it_1.next(); !nextValue.done; nextValue = it_1.next()) {
                    if (callback(nextValue.value, _k++, list) === false) {
                        break;
                    }
                }
            }
            return;
        }
        // Handle object iteration
        if (isFunction(list.hasOwnProperty)) {
            for (_k in list) {
                if (list.hasOwnProperty(_k)) {
                    // Try to translate string keys
                    var kReal = _k;
                    if (typeof _k === 'string') {
                        var kInt = void 0;
                        var kFloat = void 0;
                        if ((kInt = parseInt(_k)) + '' === _k) {
                            kReal = kInt;
                        }
                        else if ((kFloat = parseFloat(_k)) + '' === _k) {
                            kReal = kFloat;
                        }
                    }
                    if (callback(list[_k], kReal, list) === false) {
                        break;
                    }
                }
            }
            return;
        }
    }
    throw Error('Could not iterate given object!');
}
//# sourceMappingURL=forEach.js.map